import { apiV1FeedbackPost } from "@/backend-sdk/client/sdk.gen";
import type {
  FeedbackCreate,
  FeedbackReceipt,
} from "@/backend-sdk/client/types.gen";

/**
 * <M-281> O feedback das telas: o usuário conta um defeito ou sugere uma melhoria, e a
 * equipe lê pelo painel admin.
 *
 * O andamento (novo, em análise, concluído, descartado) é só do admin: a resposta não o
 * traz, e esta tela não tem como mostrá-lo.
 */

export type TipoDeFeedback = FeedbackCreate["kind"];

/** O teto do backend para o caminho da tela. */
const TAMANHO_MAXIMO_DO_CAMINHO = 500;

/** Os mínimo e máximo da mensagem, iguais aos do backend. */
export const MINIMO_DA_MENSAGEM = 10;
export const MAXIMO_DA_MENSAGEM = 5000;

export const sendFeedback = async (
  body: FeedbackCreate,
): Promise<FeedbackReceipt> => {
  const { data } = await apiV1FeedbackPost({
    body: {
      ...body,
      page_path: body.page_path.slice(0, TAMANHO_MAXIMO_DO_CAMINHO),
    },
    throwOnError: true,
  });
  return data;
};
